import {Link} from "react-router-dom";

import styles from "./ProjectList.module.css";
import ProjectPreview from "./ProjectPreview";

export default function ProjectList(props){

  const projects = props.projects;
  if (projects == null || typeof(projects["map"]) != "function")
    return (<span></span>);

  return (
    <ul className={styles.project_list}>
      {projects.map((project, index) => {
        const pageUrl = "/projects/" + project.name.toLowerCase().replaceAll(" ", "-");
        
        return (
          <li className={styles.list_item} key={index}>
            <Link to={pageUrl} className={styles.project_link}>
              <ProjectPreview name={project.name}
              description={project.description}
              images={project.previewImages}
              />
            </Link>
          </li>
        )
    })}
    </ul>

  );

}